import { Record, RecordOf } from 'immutable';
import { ProductSearchResultWithCursor } from '../../common/ProductSearchResultWithCursor';
import { FilterableProductVariant } from '../../../../services/ProductServices/LocalProduct';

export interface CloudshelfProductsSearchResultParams {
    hasMore: boolean;
    totalCount: number;
    products: ProductSearchResultWithCursor[];
}

export type CloudshelfProductsSearchResult = RecordOf<CloudshelfProductsSearchResultParams>;

export const makeSearchResult: Record.Factory<CloudshelfProductsSearchResultParams> = Record({
    hasMore: false as boolean,
    totalCount: 0,
    products: [] as ProductSearchResultWithCursor[],
});

export interface CloudshelfProductVariantSearchResultParams {
    hasMore: boolean;
    totalCount: number;
    variants: FilterableProductVariant[];
}

export type CloudshelfProductVariantsSearchResult = RecordOf<CloudshelfProductVariantSearchResultParams>;

export const makeVariantSearchResult: Record.Factory<CloudshelfProductVariantSearchResultParams> = Record({
    hasMore: false as boolean,
    totalCount: 0,
    variants: [] as FilterableProductVariant[],
});
